var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-up"},[(_vm.renderComponent)?_c('SignUp',{on:{"forceRerender":_vm.forceRerender}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }